const STAGE_LABELS: Record<string, string> = {
  PREPROCESSING_DISPATCHED: 'Preprocessing dispatched',
  VARIANT_SEGMENT_TRANSCRIPTION_DISPATCHED: 'Variant transcription dispatched',
  VARIANT_COMPARISON_DISPATCHED: 'Variant comparison dispatched',
  TRANSCRIPT_PREPARATION_DISPATCHED: 'Transcript preparation dispatched',
  ASR_REMEDIATION_DISPATCHED: 'ASR remediation dispatched',
};

// Unknown stages (including historical names) render raw.
export const formatStageLabel = (stage?: string | null) => {
  if (!stage) {
    return null;
  }
  return STAGE_LABELS[stage] ?? stage;
};

export const isDispatchStage = (stage?: string | null) => Boolean(stage && stage.endsWith('_DISPATCHED'));

export const formatServiceLabel = (service?: string | null) => {
  if (service === 'Orchestrator') {
    return 'Pipeline';
  }
  return service ?? '';
};

export const formatEtaMs = (ms: number) => {
  const totalMinutes = Math.round(ms / 60000);
  if (totalMinutes < 1) {
    return 'under a minute';
  }
  if (totalMinutes < 60) {
    return `${totalMinutes} min`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
};

export const formatWorkflowType = (type?: string | null) => {
  if (!type) {
    return '';
  }
  const trimmed = type.replace(/Workflow$/, '');
  const spaced = trimmed.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const HEARTBEAT_STALE_MS = 5 * 60 * 1000;

export const heartbeatAgeMs = (lastHeartbeatAt?: string | null) => {
  if (!lastHeartbeatAt) {
    return null;
  }
  const timestamp = new Date(lastHeartbeatAt).getTime();
  if (Number.isNaN(timestamp)) {
    return null;
  }
  return Date.now() - timestamp;
};
